import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const personnelRoleRateType = v.union(
  v.literal("hourly"),
  v.literal("per_service"),
  v.literal("fixed"),
);

export const validatorPersonnelRole = v.object({
  name: v.string(),
  description: v.optional(v.string()),
  rateType: personnelRoleRateType,
  defaultRate: v.number(),
  isActive: v.optional(v.boolean()),
  internalControl,
});

export const personnel_roles = defineTableWithInternalControl(
  validatorPersonnelRole,
)
  .index("by_name", ["name"])
  .index("by_company_and_name", ["internalControl.companyId", "name"]);
